import React from 'react';
import logo from '../../assets/perfect_shape_logo.png';

const Header = props => {
  const { header } = props;
  const { Shop, Header2, Address, Tel, Fax } = header;
  
  return (
    <div className={'header'}>
      {/* <p className={'title bold'}>{Shop}</p> */}
      <div className='h1'>
        <img className='logo' src={logo} alt='logo' />
        <p className='title bold'>必瘦站 PerfectShape</p>
      </div>
      {Header2 && <p className={'info'}>{Header2}</p>}
      <p className={'info'}>
        <span>{Address}</span>
        <span>Tel:{Tel} Fax: {Fax}</span>
      </p>
    </div>
  );
};

export default Header;